import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialInput from "../../components/MaterialInput";
import "./targetreport.css";
import MaterialSelect from "../../components/MasterSelect";
import request from "graphql-request";
//import $ from 'jquery';

import {
  allSalesTarget,
  filteredSummary,
  filterhalfyearly,
  filtermonthly,
  halfyearly,
} from "./targetQuery";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import TableComponent from "../../components/GridTable/TableComponent";

const TargetReport = () => {
  const [yearlyData, setyearlyData] = useState([]); // setdropdown value for yearltoption
  const [targetData, settargetData] = useState([]); // all table view in one state
  const [selectOption, setSelectOption] = useState([]); // second selct input field option change
  const [targetSelect, setTargetSelect] = useState({
    targetOptions: "",
    targetOptionsStatus: "unchecked",
    particular: "",
    particularStatus: "unchecked",
  }); // halfy or monthly choose


  const { currentUser } = useAuth();
  

  const [financialyearData, setfinancialyearData] = useState({
    financialYear: "",
    financialYearStatus: "unchecked",
  }); // year field
  const [dislble, setDisble] = useState(true);

  useEffect(() => {
    const fetchYeardata = async () => {
      try {
        const res = await request(BASEURL, allSalesTarget);

        setyearlyData(res?.allSalesTarget); // setdrop down
      } catch (err) {}
    };
    fetchYeardata();
  }, []);

  const columns = [
    {
      field: "id",
      label: "S.NO",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    },

    {
      field: "username",
      label: "UserName",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    },
    targetSelect.particular && targetSelect.targetOptions.label=="Monthly"?{
      field: "targetAmount",
      label: "Target Amount",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    }:{},
    ( financialyearData.financialYear && targetSelect.targetOptions.label !=="Monthly") &&{
      field: "totalTargetAmount",
      label: "Total Target Amount" ,
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    },
    {
      field: "totalAchievedAmount",
      label: "Achieved Amount",
      flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    },
   
    {
      field: "achievementPercentage",
      label: "Achieved %",
     
       flex: 1,
      disableColumnMenu: true,
      editable: false,
      // valueGetter: (params) => params.row.index + 1,
    },
  
  ];
  const rows = targetData?.map((item, index) => ({
    id: index +1,
    username: item.username,
    targetAmount: item.targetAmount,
    totalTargetAmount: item.totalTargetAmount|| 0,
    totalAchievedAmount: item.totalAchievedAmount || 0,
    achievementPercentage: item.achievementPercentage || 0,
  }));
  const targetOption = [
    {
      value: "halfyearly",
      label: "Half Yearly",
    },
    {
      value: "quotyearly",
      label: "Quarterly",
    },
    {
      value: "monthly",
      label: "Monthly",
    },
  ];

  const target1 = [
    {
      value: "Apr-Sep",
      label: "Apr-Sep",
    },
    {
      value: "Oct-Mar",
      label: "Oct-Mar",
    },
  ];
  const target2 = [
    {
      value: "Q1",
      label: "Apr - Jun",
    },
    {
      value: "Q2",
      label: "Jul - Sep",
    },
    {
      value: "Q3",
      label: "Oct - Dec",
    },
    {
      value: "Q4",
      label: "Jan - Mar",
    },
  ];
  const target3 = [
    {
      value: "2026-01-01",
      label: "Jan",
    },
    {
      value: "2026-02-01",
      label: "Feb",
    },
    {
      value: "2026-03-01",
      label: "Mar",
    },
    {
      value: "2025-04-01",
      label: "Apr",
    },
    {
      value: "2025-05-01",
      label: "May",
    },
    {
      value: "2025-06-01",
      label: "Jun",
    },
    {
      value: "2025-07-01",
      label: "Jul",
    },
    {
      value: "2025-08-01",
      label: "Aug",
    },
    {
      value: "2025-09-01",
      label: "Sep",
    },
    {
      value: "2025-10-01",
      label: "Oct",
    },
    {
      value: "2025-11-01",
      label: "Nov",
    },
    {
      value: "2025-12-01",
      label: "Dec",
    },
  ];
  const target4 = [
    {
      value: "1",
      label: "target4",
    },
  ];
  //   var now = new Date();
  //   var oneYr = new Date();
  // oneYr.setYear(now.getYear() + 1);
  // $("#yearFromNow").append(oneYr.toString());

  const handleTargetChange = (event, selectevent) => {
    const targetData = { ...targetSelect };

    if (selectevent?.name == "targetOptions") {
      if (event?.value == "halfyearly") {
        setSelectOption(target1);
      } else if (event?.value == "quotyearly") {
        setSelectOption(target2);
      } else if (event?.value == "monthly") {
        setSelectOption(target3);
      } else if (event?.value == 4) {
        setSelectOption(target4);
      } else {
        setSelectOption([]);
      }
      if (event?.label) {
        targetData[selectevent.name + "Status"] =
          event?.label === undefined ? "unchecked" : "success";
        setDisble(false);
      } else {
        targetData[selectevent.name + "Status"] =
          event?.label == undefined ? "unchecked" : "error";
        targetData["particular"] = "";
        targetData["particularStatus"] = "unchecked";
        setDisble(true);
      }
      targetData["targetOptions"] = event;
      targetData.particular = "";
      targetData.particularStatus = "unchecked";
    }
    if (selectevent?.name == "targetOptions") {
    } else if (selectevent?.name == "particular") {
      if (targetSelect.targetOptions?.value == "halfyearly") {
        request(BASEURL, filteredSummary, {
          filterType: "halfyearly",
          year: `${financialyearData.financialYear.value} ${event.value}`,
        }).then((res) => settargetData(res.filteredSummary));
      } else if (targetSelect.targetOptions?.value == "quotyearly") {
        request(BASEURL, filteredSummary, {
          filterType: "quotyearly",
          year: `${event.value} ${financialyearData.financialYear.value}`,
        }).then((res) => settargetData(res.filteredSummary));
      } else if (targetSelect.targetOptions?.value == "monthly") {

        request(BASEURL, filtermonthly, {
          filterType: "monthly",
          year: `${event.value.toString()}`,
        }).then((res) => settargetData(res.filteredSummary));
      }
      targetData.particular = event;
      targetData.particularStatus = event ? "success" : "error";
    }

    setTargetSelect(targetData);
  };
  const handleYearlyChange = (e) => {
    // const newdata = { ...financialyearData };

    if (e?.value != undefined) {
      request(BASEURL, filteredSummary, {
        filterType: "yearly",
        year: e?.value,
      }).then((res) => settargetData(res?.filteredSummary));

      const obj = {
        financialYear: e,
        financialYearStatus: "success",
      };
      setfinancialyearData(obj);
    } else {
      const obj = {
        financialYear: "",
        financialYearStatus: "unchecked",
      };
      setTargetSelect({
        targetOptions: "",
        targetOptionsStatus: "unchecked",
        particular: "",
        particularStatus: "unchecked",
      });
      setfinancialyearData(obj);
      settargetData([]);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }
  return (
    <DashboardLayout>
      <Card>
        {(currentUser?.role == "superuser" || currentUser?.role == "Manager") && (
          <>
            <CardHeader
              title={
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Sales Target Report Filters
                    </MaterialTypography>
                      <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ marginRight: "20px" }}>
                      <MaterialSelect
                        name="financialYear"
                        value={financialyearData.financialYear}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handleYearlyChange} //selectedValue, event
                        options={yearlyData?.map((item) => {
                          return {
                            value: item?.financialYear,
                            label: item?.financialYear,
                          };
                        })}
                        error={
                          financialyearData.financialYearStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          financialyearData.financialYearStatus === "success"
                            ? true
                            : false
                        }
                      
                      />
                    </div>
                    <div style={{ marginRight: "20px" }}>
                      <MaterialSelect
                        name="targetOptions"
                        value={targetSelect.targetOptions}
                        // value={financialyearData.financialYear}
                        // customStyles={{ optionPadding: 20 }}
                        onChange={handleTargetChange} //selectedValue, event
                        options={targetOption?.map((item) => {
                          return {
                            value: item?.value,
                            label: item?.label,
                          };
                        })}
                        error={
                          targetSelect.targetOptionsStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          targetSelect.targetOptionsStatus === "success"
                            ? true
                            : false
                        }
                        isDisabled={!financialyearData.financialYear}
                    
                      />
                    </div>
                    <div>
                      <MaterialSelect
                        name="particular"
                        value={targetSelect.particular}
                        customStyles={{ optionPadding: 20 }}
                        onChange={handleTargetChange} //selectedValue, event
                        options={selectOption?.map((item) => {
                          return {
                            value: item?.value,
                            label: item?.label,
                          };
                        })}
                        error={
                          targetSelect.particularStatus === "error"
                            ? true
                            : false
                        }
                        success={
                          targetSelect.particularStatus === "success"
                            ? true
                            : false
                        }
                        isDisabled={dislble}
                        // isClearable
                      />
                    </div>
                  </div>
                  </Stack>

                
                </Stack>
              }
            />
            <TableComponent
            rowsData={rows}
            columns={columns}
            onCheck={onCheck}
            head="Sales Target Report"
            />
            {/* <MaterialDataGrid
              // customHeight={550}
              rows={rows}
              columns={columns}
              // checkboxSelection={false}
              isSelectable={false}
            /> */}
            {/* <CardContent sx={{ minHeight: "70vh" }}>
              <div style={{ marginTop: "-25px" }}>
                <div className="tabel-target">
                  <table>
                    <thead>
                      <tr style={{ fontSize: "15px" }}>
                        <th style={{ fontWeight: "500" }}>S.NO</th>
                        <th style={{ fontWeight: "500" }}>Target</th>
                        <th style={{ fontWeight: "500" }}>Achieved</th>
                        <th style={{ fontWeight: "500" }}>Achieved %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {targetData?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.username}</td>
                          <td>
                            {item?.targetAmount
                              ? item?.targetAmount
                              : item?.totalTargetAmount
                              ? item?.totalTargetAmount
                              : 0}
                          </td>
                          <td>{item?.totalAchievedAmount || 0}</td>
                          <td>{item?.achievementPercentage || 0}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </CardContent> */}
          </>
        )}
      </Card>
    </DashboardLayout>
  );
};

export default TargetReport;
